// extracted by mini-css-extract-plugin
module.exports = {"Colored":"Navigation_Colored__DlnOQ"};